export function autoupdateCurrentTime(tick: () => void, intervalMs: number) {
  return setInterval(() => {
    tick();
  }, intervalMs);
}
